interface PackageCardProps {
  title: string;
  price: number;
  disclaimer?: string;
  buttonText: string;
  onButtonClick: () => void;
  features: string[];
}

export default function PackageCard({ title, price, disclaimer, buttonText, onButtonClick, features }: PackageCardProps) {
  return (
    <div className="flex flex-col items-center rounded-xl border border-border/60 bg-card p-6 shadow-sm">
      <h2 className="text-xl font-bold text-foreground">{title}</h2>
      <h3 className="mt-2 text-2xl font-semibold text-primary">{price} € per month</h3>
      <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
        {features.map((feature) => (
          <li key={feature} className="flex items-start gap-2">
            <span className="mt-0.5 text-primary">•</span>
            {feature}
          </li>
        ))}
      </ul>
      {disclaimer && <p className="mt-3 text-xs text-muted-foreground">{disclaimer}</p>}
      <button
        onClick={onButtonClick}
        type="button"
        className="mt-6 rounded-md bg-primary px-6 py-2 text-sm font-medium text-white hover:bg-primary-hover transition-colors"
      >
        {buttonText}
      </button>
    </div>
  );
}
